import { Component, ElementRef, OnDestroy, ViewChild } from "@angular/core";
import { LayoutService } from "./service/app.layout.service";
import { AuthService } from "../core/auth/services/auth.service";
import { AlertHistorySessionService } from "../features/alerts/services/alert-history-session.service";
import { ThemeService } from "../core/services/theme.service";
import { environment } from "../../environments/environment";

@Component({
  selector: "twx-sidebar",
  templateUrl: "./app.sidebar.component.html",
  standalone: false,
})
export class AppSidebarComponent implements OnDestroy {
  /** Hide session-bound controls (e.g. Sign Out) in the client-preview build. */
  readonly previewMode = environment.previewMode;

  timeout: ReturnType<typeof setTimeout> | null = null;
  @ViewChild("menuContainer") menuContainer!: ElementRef;
  constructor(
    public layoutService: LayoutService,
    public theme: ThemeService,
    public el: ElementRef,
    private auth: AuthService,
    private alertHistorySession: AlertHistorySessionService,
  ) {}

  get logoColor() {
    let logo;

    if (this.layoutService.config().colorScheme == "light") {
      logo =
        this.layoutService.config().menuTheme === "white" ||
        this.layoutService.config().menuTheme === "orange"
          ? "dark"
          : "white";
    } else {
      logo = "dark";
    }
    return logo;
  }
  onMouseEnter() {
    if (!this.layoutService.state.anchored) {
      if (this.timeout) {
        clearTimeout(this.timeout);
        this.timeout = null;
      }
      this.layoutService.state.sidebarActive = true;
    }
  }

  onMouseLeave() {
    if (!this.layoutService.state.anchored) {
      if (!this.timeout) {
        this.timeout = setTimeout(
          () => (this.layoutService.state.sidebarActive = false),
          300,
        );
      }
    }
  }

  resetOverlay() {
    if (this.layoutService.state.overlayMenuActive) {
      this.layoutService.state.overlayMenuActive = false;
    }
  }

  anchor() {
    this.layoutService.state.anchored = !this.layoutService.state.anchored;
  }

  logout() {
    // Alert History users leave to the logout_url they arrived with (TWX-536)
    if (this.alertHistorySession.hasSession) {
      this.alertHistorySession.endSession();
      return;
    }

    this.auth.logout();
  }

  ngOnDestroy() {
    this.resetOverlay();
  }
}
